/*
* Extension of reel part creator to hopefully solve spine symbol specific challenges, e.g limit number of instances etc.
*/

import {ReelPartCreator} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelPartCreator";
import {ISymbolStateConfig, StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {BasicStateReelSymbol} from "../symbols/BasicStateReelSymbol";

export class SpineReelPartCreator extends ReelPartCreator {

    private readonly _spineSymbolCreator:(symName:string, reelId:number, state?:ISymbolStateConfig, spineInstance?:PIXI.spine.Spine) => StateReelSymbol;

    private _spineInstances: {
        symName:string,
        instance:PIXI.spine.Spine,
        active:boolean
    } [] = [];

    private _dumpList:number [] = [];



    constructor(newSymbolCreator?:(symName:string, reelId:number, state?:ISymbolStateConfig) => StateReelSymbol) {
        super();
        if(newSymbolCreator != undefined) {
            this._spineSymbolCreator = newSymbolCreator;
        }
    }

    public createNewSymbol(symName:string, reelId:number, state?:ISymbolStateConfig):StateReelSymbol {
        if(this._spineSymbolCreator) {
            return this._spineSymbolCreator(symName, reelId, state);
        }
        return new StateReelSymbol(symName, reelId, state);
    }

    public deleteSymbol(symbol:StateReelSymbol) {

        // reset spine instance and set as inactive
        //this.onRemoveSpineInstance(<BasicStateReelSymbol> symbol);

        symbol.onRemove();
    }

    protected onCreateSpineInstance(symName:string):PIXI.spine.Spine {
        let inactiveInstanceName:string | undefined;
        let inactiveInstance:PIXI.spine.Spine | undefined;
        let inactiveIndex:number = -1;

        for(let i = 0; i < this._spineInstances.length; i++) {
            if(this._spineInstances[i].symName === symName && !this._spineInstances[i].active) {
                inactiveInstanceName = this._spineInstances[i].symName;
                inactiveInstance = this._spineInstances[i].instance;
                inactiveIndex = i;
                break;
            }
        }

        if(inactiveInstance) {
            console.log("giving inactive");
            return inactiveInstance;
        }
        else {
            const newInstance:PIXI.spine.Spine = this.createIdleSpineInstance(symName);
            this._spineInstances.push({
                "active": true,
                "instance": newInstance,
                "symName": symName
            });

            console.log("creating new");
            return newInstance;
        }
        //console.log("inactive instance: " + inactiveInstanceName);
    }

    protected onRemoveSpineInstance(symbol:BasicStateReelSymbol):void {
        // reset spine
        // set inactive
        if(symbol) {
            let activeSpineInstance:PIXI.spine.Spine | undefined; // = symbol.spineInstance; // TODO: removed from symbol
            if(activeSpineInstance) {
                if(activeSpineInstance.state) {
                    //activeSpineInstance.skeleton.setToSetupPose();
                }
                if(activeSpineInstance) {
                    //activeSpineInstance.state.tracks = [];
                }
            }
            for(let i = 0; i < this._spineInstances.length; i++) {
                if(this._spineInstances[i].instance === activeSpineInstance) {
                    // set for inactive
                    this._dumpList.push(i);
                    //this._spineInstances[i].active = false;
                }
            }

            console.log("dump list: " + this._dumpList);
            //console.log()
        }
    }

    protected createIdleSpineInstance(symName:string = "", track:number = 0):PIXI.spine.Spine {
        const spine = new PIXI.spine.Spine(GameResources.getSpineAsset(symName + "_idle"));
        spine.autoUpdate = true;
        spine.state.setAnimation(track, symName + "-idle", true);

        if(symName === "S") {
            spine.state.timeScale = 0.65;
        }
        else {
            spine.state.timeScale = 0.3;
        }

        return spine;
    }

}
